export default __webpack_public_path__ + "static/media/main-coin.47203b8e.png";